import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

class Header extends Component {
    render() {
        const title = window.config.page_title;
        return (<header className="header grid">
            <div className="container">
                <div className="row">
                    <Link to="/" className="slogan">{title}</Link>
                    {this.props.user ? <ul className="nav-list">
                        <li>
                            <Link to="/app/games">Mano rungtynės</Link>
                        </li>
                        <li>
                            <Link to="/app/games/new">Pridėti rungtynes</Link>
                        </li>
                        <li>
                            <Link to="/logout">Atsijungti</Link>
                        </li>
                    </ul> : null}

                </div>
            </div>
        </header>);
    }
}


export default connect((state) => {
    return {
        user: state.user.currentUser
    };
})(Header);



// WEBPACK FOOTER //
// ./src/js/layout/header.jsx